import produce from '../../produce';

import * as types from './types';

const initialState = {
  content: [],
  showPromotion: true,
  showPromotionsLoader: true
};

/* eslint-disable consistent-return */
/* eslint-disable default-case */
/* eslint-disable no-param-reassign */
const reducer = produce((draft, action) => {
  switch (action.type) {
    case types.PROMOTIONS_SET_PROMOS:
      draft.content = action.payload.data.attributes.entries;
      break;
    case types.SHOW_PROMOTION:
      draft.showPromotion = action.payload;
      break;
    case types.SHOW_LOADER:
      draft.showPromotionsLoader = action.payload;
      break;
  }
}, initialState);

export default reducer;
